// frontend/src/config/games.ts
//
// Game Center'daki tüm oyunların merkezi kayıt listesi.
// Yeni bir oyun eklemek için buraya tek bir kayıt eklemek yeterlidir;
// GameCenter sayfası bu listeyi okuyarak kartları otomatik oluşturur.

export type GameStatus = 'available' | 'coming-soon';

export interface GameDefinition {
  /** Benzersiz oyun kimliği (route ve key için kullanılır) */
  id: string;
  /** Kart üzerinde gösterilen isim */
  title: string;
  /** Kart ikonu — sadece emoji kullanılır */
  emoji: string;
  /** Kısa açıklama */
  description: string;
  /** Oyun sayfasının route path'i (yalnızca status 'available' iken geçerli) */
  path: string;
  /** Oyunun oynanabilir olup olmadığı */
  status: GameStatus;
}

export const GAMES: GameDefinition[] = [
  {
    id: 'memory',
    title: 'Hafıza Oyunu',
    emoji: '🧠',
    description: 'Kartları çevir, eşleri bul! Hafızanı test et.',
    path: '/games/memory',
    status: 'available',
  },
  {
    id: 'snake',
    title: 'Yılan',
    emoji: '🐍',
    description: 'Klasik yılan oyunu — yemleri topla, büyü.',
    path: '/games/snake',
    status: 'available',
  },
  {
    id: 'sudoku',
    title: 'Sudoku',
    emoji: '🧩',
    description: 'Sayı bulmacasıyla mantığını geliştir.',
    path: '/games/sudoku',
    status: 'available',
  },
  {
    id: 'tic-tac-toe',
    title: 'Tic Tac Toe',
    emoji: '❌',
    description: 'Klasik XOX oyunuyla bir arkadaşınla yarış.',
    path: '/games/tic-tac-toe',
    status: 'available',
  },
  {
    id: 'tetris',
    title: 'Tetris',
    emoji: '🧱',
    description: 'Blokları dizerek satırları temizle.',
    path: '/games/tetris',
    status: 'available',
  },
];
